<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" title="Chỉnh sửa tài khoản" icon="fas fa-pen-nib" />
    <el-form v-if="user" :model="changeSubscriptionForm" ref="resetPasswordForm" :hide-required-asterisk="true">
      <h5 class="text-center">Thay đổi thông tin tài khoản "{{ user.email }}"</h5>
      <br />
      <el-form-item label="Loại tài khoản" prop="pricingPlan">
        <el-button-group>
          <el-button
            v-for="plan in pricingPlans"
            :key="plan.id"
            :type="changeSubscriptionForm.pricingPlanId === plan.id ? 'primary' : 'default'"
            @click="changeSubscriptionForm.pricingPlanId = plan.id"
          >
            {{ plan.name }}
          </el-button>
        </el-button-group>
      </el-form-item>

      <el-form-item label="Hạn tài khoản" prop="confirmPassword">
        <el-date-picker v-model="changeSubscriptionForm.to" type="date" placeholder="Pick a day"> </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
      <CommonButton type="primary" @click="onSubmit" :ref="refs.CONFIRM_BUTTON">Thay đổi</CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import { updateSubscription } from '@/services/user_service.js'
import ModalHeader from '@/components/common/ModalHeader.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import { apiGetAllPricingPlan } from '@/services/pricing_plan_service.js'

export default {
  name: 'EditUserModal',
  components: { ModalHeader, CommonButton },
  data() {
    return {
      show: false,
      user: true,
      changeSubscriptionForm: {
        pricingPlanId: null,
        to: Date(),
      },
      pricingPlans: [],
      refs: {
        CONFIRM_BUTTON: 'CONFIRM_BUTTON',
      },
    }
  },
  async mounted() {
    this.pricingPlans = (await apiGetAllPricingPlan()).data
  },
  methods: {
    showModal(user) {
      this.user = user
      this.show = true
      console.log(user)
      this.changeSubscriptionForm = {
        pricingPlanId: user.subscription.plan.id,
        to: user.subscription.to,
        userId: user.id,
      }
    },
    closeModal() {
      this.show = false
    },
    async onSubmit() {
      let response = await updateSubscription(this.changeSubscriptionForm)
      if (response) {
        this.$message.success('Cập nhật thành công')
        this.$emit('success')
        this.closeModal()
      } else {
        this.$message.error('Có lỗi xảy ra')
      }
    },
  },
}
</script>

<style scoped></style>
